import XLSX from 'xlsx'

class Dataloading {
  constructor() {
    this.getFile = this.getFile.bind(this)
    this.loadData = this.loadData.bind(this)
    this.loadScript = this.loadScript.bind(this)
  }



  getFile(url, name) {

    return new Promise( (resolve, reject) => {
      var xhr = new XMLHttpRequest();
      let extension = url.split('.').pop()
      xhr.open("GET", url + "?rand=" + Math.floor(Math.random() * 100000));
      if(extension === "xlsx") xhr.responseType = "arraybuffer";

      xhr.send();

      xhr.onload = (e) => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {

            let parsed = this.parseFileContent(extension === "xlsx" ? xhr.response : xhr.responseText, extension)

            resolve({data: parsed, name})

          } else {
            console.error(xhr.statusText);
          }
        }
      }
      xhr.onerror = (e) => {
        console.error(xhr.statusText);
      };

    })
  }


  parseFileContent(content, extension) {
    let parsed
    if(extension === "json") {
      parsed = JSON.parse(content)
    } else if(extension === "data") {
      let d = JSON.parse(content)
      if(d.infos && d.infos.version === 2) {
        let coltypes = {}
        d.columns.forEach(c => coltypes[c.name] = c.type)
        parsed = d.data.map(obj => {
          for(let k in obj) {
            if(coltypes[k] === "numeric" && obj[k]) obj[k] = parseFloat(obj[k])
          }
          return obj
        })
      } else {
        parsed = []
        d.data.map(line => {
          let lineObj = {}
          d.columns.forEach(({title, type}, index) => {
            let value = line[index]
            value = value === "" ? null : value
            if(type === "numeric" && value) {
              value = parseFloat(value)
            }
            lineObj[title] = value
          })
          parsed.push(lineObj)
        })
      }
    }
    else if (extension === "xlsx") {
      parsed = XLSX.read(content, { type:"array" })
    }else {
      parsed = content
    }

    return parsed
  }


  loadData(files) {

    let promises = []


    for (let name in files) {
      promises.push( this.getFile(files[name], name) )
    }


    return Promise
    .all(promises)
    .then(_files => {
      _files.forEach(({name, data}) => {
        this[name] = data
      })
    })
  }

  getScenarioFile(scenarioFile) {
    return this.getFile(window.CONFIG.scenarios.localPath + scenarioFile.name, null)
    .then(({data, name}) => {
      return JSON.parse(data)
    })
    .catch(error => {
      console.log('Error parsing scenario file', error)
    })
  }

  loadScenarioFile(scenarioFile) {
    return this.getScenarioFile(scenarioFile)
    .then(data => {
      this.scenario = data
    })
  }


  loadTranslationsFiles(files) {
    let promises = []
    for (let name in files) {
      promises.push( this.getFile(files[name], name) )
    }

    return Promise
    .all(promises)
    .then(files => {
      files.forEach(({name, data}) => {
        this[name] = data
      })
    })
  }

  loadScripts() {
    let promises = window.CONFIG.requiredScripts.map(url => this.loadScript(url))
    return Promise.all(promises)
  }

  loadScript(url) {
    return new Promise((resolve, reject) => {
      var script = document.createElement('script');
      document.head.appendChild(script);
      script.onload= function() {
        resolve()
      }
      script.onerror = function() {
        reject("error loading " + url)
      }
      script.src = url
    })
  }
}


export default new Dataloading()
